import favicon from "../../images/elements/500.webp"
import logo from "../../../../public/logo/logo.webp"
import logoLine from "../../../../public/logo/logoLine.webp"

export const DynamicMedia = {
    favicon: favicon,
    logo: logo,
    logoLine: logoLine,
    mobileLogo: logoLine,
    logoLight: logoLine,
}